import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-audio",
  "use": "icon-audio-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-audio\">\r\n<title>file_audio</title>\r\n<path fill=\"#b780ed\" d=\"M7.333 0.667h14l8 8v18c0 2.2-1.8 4-4 4h-18c-2.2 0-4-1.8-4-4v-22c0-2.2 1.8-4 4-4zM20.933 11.667l-6.8 1.8c-0.8 0.4-1.4 1-1.4 1.8v6.4c0 0-0.6-0.4-1.6-0.2-1.4 0.2-2.8 1.4-2.8 2.6s1.4 1.8 2.8 1.6c1.6-0.2 2.8-1.2 2.8-2.4v-6.2c0-0.4 0.8-0.8 0.8-0.8l5.8-1.6c0 0 0.6-0.2 0.6 0.4v5c0 0-0.6-0.4-1.6-0.2-1.6 0.2-2.8 1.2-2.8 2.4s1.4 2 2.8 1.8c1.4-0.2 2.8-1.2 2.8-2.4v-9c0-0.8-0.8-1.2-1.4-1z\" />\r\n<path fill=\"#e0e0e0\" opacity=\"0.619\" d=\"M21.333 0.667l8 8h-6c-1.2 0-2-0.8-2-2v-6z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/audio.svg
// module id = KyOe
// module chunks = 14